import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { Store } from "@ngrx/store";
import { AngularFireDatabase } from "angularfire2/database";
import { AlertController, LoadingController, MenuController, ModalController, ToastController } from "ionic-angular";
import { isString } from "ionic-angular/util/util";
import { isValidEventId } from "../helpers/utils.helper";
import { getColor } from "../pipes/color/color.helper";
import { Observable } from "rxjs/Observable";
import { isObject } from "util";
import * as sharedSelectors from "../shared/reducers/shared.reducer";

@Injectable()
export class Utilities {
  private clientId: string;

  constructor(
    public afDb: AngularFireDatabase,
    private http: HttpClient,
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private store: Store<{}>,
  ) {
    this.store.select(sharedSelectors.getClientId).subscribe((clientId: string) => {
      if (clientId) {
        this.clientId = clientId;
      }
    });
  }

  public createToast(message: string, duration = 2000, position = "bottom") {
    const toast = this.toastCtrl.create({ message, duration, position });
    toast.present();
    return toast;
  }

  get FroalaKey() {
    return {
      imageUploadMethod: "POST",
      imageUploadParam: "image_param",
      imageUploadParams: { id: this.clientId },
      imageUploadURL: `${ENV.backend}/util/image/upload`,
      key: ENV.froalaKey,
      heightMin: 100,
      heightMax: 300,
      documentReady: false,
      theme: "royal",
    };
  }

  public insertExcelOnChildClient(client: string, url: string, path: string, replace: boolean) {
    return this.http.post(`${ENV.backend}/util/csv`, { client, url, path, replace });
  }

  public setLoading(message: string = null) {
    const load = this.loadingCtrl.create({
      dismissOnPageChange: true,
    });

    if (message) {
      load.setContent(message);
    }

    load.present();

    return load;
  }

  public validateEventIdParam(eventId: string) {
    return (
      eventId !== "--" &&
      eventId !== "" &&
      eventId !== undefined &&
      eventId !== "undefined" &&
      eventId !== "%3AeventId" &&
      eventId !== ":eventId" &&
      eventId !== null &&
      eventId !== "null"
    );
  }

  public convertSecondsToTime(seconds) {
    const d = Number(seconds);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);

    return `${m < 10 ? "0" + m : m}:${s < 10 ? "0" + s : s}`;
  }

  public getDefaultCategories() {
    return this.getStaticInformationPromise("DefaultCategories")
      .once("value")
      .then((snap) => snap.val());
  }

  get suggestionList(): { name, value }[] {
    return [
      { name: 'Productos', value: 'product_list' },
      { name: 'Ticketes', value: 'ticket_list' },
      { name: 'Servicios', value: 'service_list' },
      { name: 'Eventos', value: 'event_list' },
      { name: 'Cupones', value: 'coupon_list' },
      { name: 'Stand', value: 'stand_list' },
      { name: 'Staff', value: 'staff_list' },
      { name: 'Noticias', value: 'news_list' },
    ];
  }

  get defaultModulesProfileUsers(): string[] {
    return [
      "admin_stands",
      "admin_coupons",
      "admin_agenda",
      "admin_staff",
      "admin_resources",
    ];
  }

  public getDefaultModulesEventList(): string[] {
    return [
      "home",
      "gallery",
      // "plan_my_day",
      "notification",
      // "my_reserves",
      "favorites",
      "diary",
      "carnet",
      "staff",
      "news",
      // "ticket",
      // "reserve",
      "questions",
      "opinometer",
      "messages",
      // "catalog",
      "sponsor",
      // "sponsor_banner",
      "networking",
      "resource",
      "coupons",
      "stand",
      // "custom_payment",
      "map",
      "streaming",
      // "services",
      "employee",
      "social",
      // "voting",
      "embed",
      "countdown",
      // "checkin",
      "share_pages",
      "custom_favorites",
      // "jobs",
      // "scan-ticket",
      "timeline",
      "custom",
      "livestream",
      "open_mic"
      // "interactivity",
      // "stand",
    ];
  }

  public getDefaultModulesEventDefault(): string[] {
    return [
      "notification",
      "my_reserves",
      "diary",
      "staff",
      "news",
      "catalog",
      "sponsor",
      "networking",
      "countdown",
      "resource",
      "raffle",
      "commercial_samples",
      "map",
      "streaming",
      "social",
      "home",
    ];
  }

  public getTypesEvents(): string[] {
    return [
      "soccer",
      "golf",
      "party",
      "private",
      "public",
    ];
  }

  public getDefaultModulesClientList(): string[] {
    return [
      "gallery",
      // "plan_my_day",
      "notification",
      // "pay_methods",
      // "my_reserves",
      "diary",
      "favorites",
      "event",
      "staff",
      "likes",
      "news",
      "notes",
      "questions",
      "opinometer",
      "messages",
      // "catalog",
      // "shopping_cart",
      "sponsor",
      // "sponsor_banner",
      "networking",
      // "business",
      // "gamification",
      "resource",
      "coupons",
      // "referred",
      // "raffle",
      "carnet",
      "stand",
      // "custom_payment",
      // "ticket",
      // "reserve",
      // "guest",
      // "services",
      // "employee",
      // "beneficiary",
      "pqr",
      "embed",
      // "directory",
      // "sostenimiento",
      "terms",
      "legal_terms_service",
      "custom_favorites",
      // "jobs",
      // "scan-ticket",
      "timeline",
      "upload_massive",
      "custom",
      "livestream",
      "companies",
      // "share_pages",
      "open_mic"
    ];
  }

  public generateRamdomKey() {
    return this.afDb.createPushId();
  }

  public copyToClipboard(idElement) {
    const element: any = document.getElementById(idElement);
    element.select();
    document.execCommand("copy");
    // element.setSelectionRange(0, 0);
    this.Toast.create({
      duration: 2000,
      message: `Copied to clipboard "${element.value}"`,
      position: "bottom",
    }).present();
  }

  public defaultModuleConfig(module) {
    return new Promise((res, rej) => {
      if (module === "embed") {
        return res({
          title: {
            en: "Null",
            es: "Null",
          },
          order: "-1",
          icon: {
            name: "md-paper",
            type: "Ionic",
          }
        });
      }

      this.http.get("./assets/json/modules_config.json").subscribe((config) => {
        if (config) {
          res(config[module]);
        } else {
          rej(`Module ${module} not found`);
        }
      });
    });
  }

  public getCurrencies() {
    return new Promise((res) => {
      this.http.get("./assets/json/currency.json").subscribe((currency) => res(currency));
    });
  }

  public transformImages(payload: { name: { imageUrl: string, folderName: string, imageName: string, relation: string } }[]): Promise<any> {
    return this.http.post(`${ENV.api_url}/v1/utils/images`, payload).toPromise();
  }

  public parseDataInt(value) {
    return value ? parseInt(value, 10) : "";
  }

  public getStaticInformation(ref: string): Observable<any[]> {
    return this.afDb
      .list<any>(`StaticInformation/${ref}`)
      .valueChanges();
  }

  public getAdditionalServices(clientId: string): Observable<any[]> {
    return this.afDb
      .list<any>(`Clients/${clientId}/AdditionalServices`)
      .valueChanges();
  }

  public getChildData(child): Observable<any> {
    return this.afDb.list<any>(child).valueChanges();
  }
  public setAdditionalServices(clientId: string, services: any): Promise<any> {
    if (services.id === "") {
      services.id = this.afDb.createPushId();
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${clientId}/AdditionalServices/${services.id}`)
        .update(services)
        .then(() => resolve(services))
        .catch((error) => reject(error));
    });
  }

  public getStaticInformationPromise(ref: string) {
    return this.afDb
      .list<any>(`StaticInformation/${ref}`).query.ref;
  }

  public getStaticInformationById(ref: string, refId: string): Observable<any> {
    return this.afDb
      .object<any>(`StaticInformation/${ref}/${refId}`)
      .valueChanges();
  }

  public isClearColor(colorHexa) {
    switch (colorHexa) {
      case "#fff":
      case "#f4f4f4":
        return "#000";
      default:
        return colorHexa;
    }
  }

  public getInvalidControlsForm(form: any) {
    const fields = [];
    Object.keys(form.controls).map((k) => {
      if (form.controls[k].status !== "VALID") {
        fields.push({ [k]: form.controls[k].status });
      }
    });
    return fields;
  }

  public getColors() {
    return getColor()
  }

  public getIcons() {
    return this.getStaticInformationPromise("IonIcons")
      .once("value")
      .then((snap) => snap.val());
  }

  public getIconsCustom() {
    return this.getStaticInformationPromise("IconCustom")
      .once("value")
      .then((snap) => snap.val());
  }

  public getRebusIcons(type = null) {
    let search: any = ENV.rebus_icon;
    let icon;
    if (type) {
      search = type;
    }
    switch (search) {
      case "light":
        icon = "RebusIconsLight";
        break;
      case "regular":
        icon = "RebusIconsRegular";
        break;
      case "bold":
        icon = "RebusIconsBold";
        break;
      case "rebus":
        icon = "RebusIcons";
        break;
      case "ionic":
        icon = "IonIcons";
        break;
    }
    return this.getStaticInformationPromise(icon)
      .once("value")
      .then((snap) => snap.val());
  }

  public getRebusIconsObs(type = null) {
    let search: any = ENV.rebus_icon;
    let icon;
    if (type) {
      search = type;
    }
    switch (search) {
      case "light":
        icon = "RebusIconsLight";
        break;
      case "regular":
        icon = "RebusIconsRegular";
        break;
      case "bold":
        icon = "RebusIconsBold";
        break;
      case "rebus":
        icon = "RebusIcons";
        break;
      case "ionic":
        icon = "IonIcons";
        break;
    }
    return this.afDb
      .list<any>(`StaticInformation/${icon}`).valueChanges();
  }

  get Alert() {
    return this.alertCtrl;
  }

  get Modal() {
    return this.modalCtrl;
  }

  get Toast() {
    return this.toastCtrl;
  }

  public setToast(message: string, duration: number = 2000, position: "top" | "middle" | "buttom" = "buttom") {
    return this.Toast.create({
      duration,
      message,
      position,
    }).present();
  }

  public generateID(initFlag = false, length = 6) {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    if (isString(initFlag)) { text += initFlag; }
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

  public getMaterialIcons() {
    return this.getStaticInformationPromise("MaterialIcons")
      .once("value")
      .then((snap) => snap.val());
  }

  public getFontAwsomeIcons() {
    return this.getStaticInformationPromise("FontAwesomeIcons")
      .once("value")
      .then((snap) => snap.val());
  }

  public consoleLog(text = "", data: any) {
    if (ENV.mode === "Development") {
      // tslint:disable-next-line:no-console
      console.log(text, data);
    }
  }

  public consoleWarn(text = "", data: any) {
    if (ENV.mode === "Development") {
      console.warn(text, data);
    }
  }

  public consoleDecorator(text = "", data: any, color = "#CC732E") {
    if (ENV.mode === "Development") {
      // tslint:disable-next-line:no-console
      console.log(`%c ${text}`, `background: ${color}; color: white; display: block;`, data);
    }
  }

  public consoleError(text = "", data: any) {
    // tslint:disable-next-line:no-console
    console.log(`%c ${text}`, `background: red; color: white; display: block;`, data);
  }

  get isOpen() {
    return this.menuCtrl.isOpen();
  }

  get isClose() {
    return !this.menuCtrl.isOpen();
  }

  public underConstruction() {
    this.menuCtrl.close("main-menu");
    this.alertCtrl.create({
      buttons: [{
        role: "cancel",
        text: "Ok",
      }],
      // tslint:disable-next-line:max-line-length
      message: "At the moment this action is in maintenance. Please try again later or contact the Rebus Event Tech support!",
      title: "In maintenance",
    }).present();
  }

  public timeDifference(date2, date1 = null) {
    if (!date1) { date1 = new Date().getTime(); }
    let difference = date1 - date2;

    const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
    difference -= daysDifference * 1000 * 60 * 60 * 24;

    const hoursDifference = Math.floor(difference / 1000 / 60 / 60);
    difference -= hoursDifference * 1000 * 60 * 60;

    const minutesDifference = Math.floor(difference / 1000 / 60);
    difference -= minutesDifference * 1000 * 60;

    const secondsDifference = Math.floor(difference / 1000);

    return {
      day: daysDifference,
      hour: hoursDifference,
      min: minutesDifference,
      sec: secondsDifference,
    };
  }

  public searchItem(ev: string, item: any, arrStrg: any[]) {
    let state = false;
    if (ev) {
      arrStrg.forEach((s) => {
        if (isObject(s)) {
          const keys = Object.keys(s);
          keys.forEach((k) => {
            s[k].forEach((a) => {
              if (item[k]) {
                if (item[k][a]) {
                  try {
                    if (item[k][a].toLowerCase().indexOf(ev.toLowerCase()) > -1) {
                      state = true;
                    }
                  } catch (e) {
                    this.consoleError("Error", e);
                  }
                }
              }
            });
          });
        } else if (isString(s)) {
          if (item[s]) {
            try {
              if (item[s].toLowerCase().indexOf(ev.toLowerCase()) > -1) {
                state = true;
              }
            } catch (e) {
              this.consoleError("Error", e);
            }
          }
        } else {
          state = true;
        }
      });
    } else {
      state = true;
    }

    return state;
  }

  public getIconState(state) {
    switch (state) {
      case true:
        return "md-checkmark-circle";

      case false:
        return "md-close-circle";

      case "pending":
        return "time";

      case "EXPIRED_TRANSACTION":
        return "clock";

      case "PROCESS PAYMENT":
        return "md-calculator";

      case "RESTRICTED_CARD":
      case "PAYMENT_NETWORK_REJECTED":
        return "card";

      case "ABANDONED SHOPPING CART":
      case "ABANDONED_TRANSACTION":
        return "cart";

      case "DECLINED_TEST_MODE_NOT_ALLOWED":
      case "INSUFFICIENT_FUNDS":
      case "INVALID_EXPIRATION_DATE_OR_SECURITY_CODE":
      case "failure":
      case "DECLINED":
        return "close-circle";

      case "success":
      case "CAPTURED":
      case "APPROVED":
        return "md-checkmark-circle";

      default:
        return "alert";
    }
  }

  public getColorState(state) {
    switch (state) {
      case true:
        return "secondary";

      case false:
        return "danger";

      case "pending":
      case "ABANDONED SHOPPING CART":
      case "ABANDONED_TRANSACTION":
        return "amber-800";

      case "failure":
      case "RESTRICTED_CARD":
      case "INSUFFICIENT_FUNDS":
      case "INVALID_EXPIRATION_DATE_OR_SECURITY_CODE":
      case "ABANDONED_TRANSACTION":
      case "EXPIRED_TRANSACTION":
      case "PAYMENT_NETWORK_REJECTED":
      case "DECLINED":
        return "red-900";

      case "success":
      case "CAPTURED":
      case "APPROVED":
        return "lightgreen-900";

      case "PROCESS PAYMENT":
        return "lightblue-500";

      default:
        return "primary";
    }
  }

  public getFilterTransactions(state) {
    switch (state) {
      case "success":
      case "CAPTURED":
      case "APPROVED":
        return true;

      default:
        return false;
    }
  }


  public getTimeLines(eventId: String): Observable<any[]> {
    if (isValidEventId(eventId)) {
      return this.afDb.list<any>(`/Clients/${this.clientId}/Event/${eventId}/TimeLine`)
        .valueChanges();
    }
    return this.afDb.list<any>(`/Clients/${this.clientId}/Interactivity/TimeLine`)
      .valueChanges();
  }

  public deleteTimeLines(eventId, idPic) {

    if (isValidEventId(eventId)) {
      return this.afDb.list<any>(`/Clients/${this.clientId}/Event/${eventId}/TimeLine/${idPic}`).remove();
    }
    return this.afDb.object(`/Clients/${this.clientId}/Interactivity/TimeLine/${idPic}`).remove();

  }

}
// end file



// WEBPACK FOOTER //
// ./src/providers/utilities.ts